import { render, staticRenderFns } from "./debug_panel.vue?vue&type=template&id=2461089c&scoped=true&"
import script from "./debug_panel.vue?vue&type=script&lang=js&"
export * from "./debug_panel.vue?vue&type=script&lang=js&"
import style0 from "./debug_panel.vue?vue&type=style&index=0&id=2461089c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461089c",
  null
  
)

export default component.exports